import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import { LineChart } from '@mui/x-charts/LineChart';

export default function CreatePost(){
    const [address1,setAddress1] = useState("-")
    const nowstate = useSelector(state => state);
    const [sales,setSales]= useState(nowstate.user?.sales??"-")
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())

    const handleChangeAddress = (event) => {
        setAddress1(event.target.value)
        const alamatDicari = event.target.value
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
                alamatDicari
        }).then(response=>{
            console.log(response.data)
        });
    };
    const [categorias, setCategorias] = useState([]);
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }

      const countKontrak = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/countKontrakDaily?date=${date}&dateEnd=${dateEnd}&lokasi=${address1}&statusExtend=${extend}&TipeKontrak=${TipeKontrak}&user=${sales}`,{
            
        }).then(resp => {
            console.log(resp)

    const convertData = (data, dates) => {
        return data.map((value, index) => {
            return { x: new Date(dates[index]), y: value };
        });
    };
    
    const convertDates = (dates) => {
        return dates.map(date => new Date(date));
    }

    setAdnan(resp.data.Adnan);
    setFelly(resp.data.Felly);
    setDiva(resp.data.Diva);
    setYears(convertDates(resp.data.dates));  // convert dates to Date objects before setting the state

        })
      }
      const [hitunganKontrak, setHitunganKontrak] = useState()
    const [extend,setExtend]= useState("Kontrak Aktif")
    const [TipeKontrak,setTipeKontrak]= useState("Virtual Office")
    useEffect(() => {
        const fetchData = async () => {
            await getCategorias();
            await countKontrak();
        }
        fetchData();
    },[sales, address1, extend, TipeKontrak, date, dateEnd])

    //////////////////////////////////////////Data/////////////////////////
    const [years,setYears] = useState([]);
      
      const [Adnan,setAdnan] = useState([]);
      
      const [Felly,setFelly] = useState([]);
    
      const [Diva,setDiva] = useState([]);
return(
    <Grid container>
    <Grid xs={12}>
    <LocalizationProvider dateAdapter={AdapterDateFns}>

<MobileDatePicker 
    views={['year', 'month', 'day']}
    inputFormat="dd/MM/yyyy"
    value={date}
    onChange={(value)=>setDate(value)}
    renderInput={(params) => 
        <TextField 
            {...params} 
            InputProps={{
                endAdornment: (
                    <InputAdornment >
                        <CalendarMonthIcon />
                    </InputAdornment>
                ),
            }}
        />
    }
/>

</LocalizationProvider>
    </Grid>
    <Paper>
    
       {Adnan.length > 0 && Felly.length > 0 && Diva.length > 0 ? (
  <LineChart
    xAxis={[
      {
        id: 'Years',
        data: years,
        scaleType: 'time',
        valueFormatter: (date) => `${date.getDate()}`, // format date as mm-dd-yyyy
      },
    ]}
    series={[
      {
        id: 'Adnan',
        label: 'Adnan',
        data: Adnan,
        area: true,
      },
      {
        id: 'Felly',
        label: 'Felly',
        data: Felly,
        area: true,
      },
      {
        id: 'Diva',
        label: 'Diva',
        data: Diva,
        area: true,
      },
    ]}
    sx={{
      '--ChartsLegend-itemWidth': '200px',
    }}
    width={600}
    height={400}
    margin={{ left: 70 }}
  />
) : (
  <div>No data available</div>
)}
</Paper>
    </Grid>
)
}